import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_HIDE_NAV_SAP_BUTTON_PER_PAGE = createFcmDetails('hide_nav_sap_button_per_page', {
	owner: 'Signature Growth',
	context: 'New Nav SAP Button',
	description: 'Used to hide the Nav SAP button on specific pages.',
	import: false,
	template: [],
});
